exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter:hover>a,.filter:hover>button{\n  --text-opacity: 1;\n  color: #415461;\n  color: rgba(65, 84, 97, var(--text-opacity))\n}\n.filter:hover>a:hover,.filter:hover>button:hover{\n  --text-opacity: 1;\n  color: #ffffff;\n  color: rgba(255, 255, 255, var(--text-opacity))\n}", ""]);

// exports
